/**
 * LF "Subscribe & Save" BUILDER (blocks/lf-subscribe.liquid, all products).
 *
 * A 3-step form inside the toggle panel:
 *   1. Plan     — Monthly / 3 Months / 6 Months / Yearly  (drives duration + Ends date)
 *   2. Pack size — 24 pcs / 36 pcs                          (a real product variant + price)
 *   3. Frequency — Every week / 2 weeks / month             (how often we deliver)
 *
 * On any change it recomputes deliveries, Starts/Ends and the estimated total, and
 * writes them into the hidden id / quantity / properties[...] inputs that the theme's
 * own product-form-component submits through the normal add-to-cart flow.
 */
(function () {
  if (window.__lfSubx) return;
  window.__lfSubx = true;

  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var WEEKS_PER_MONTH = 4.345;

  function fmtDate(d) {
    return d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear();
  }

  // paise -> "₹10,608" with Indian digit grouping
  function money(paise) {
    var r = Math.round(paise / 100);
    var s;
    try {
      s = r.toLocaleString('en-IN');
    } catch (e) {
      s = String(r);
    }
    return '₹' + s;
  }

  // paise -> "₹23.75" — keeps paise precision for per-unit rates
  function money2(paise) {
    var v = paise / 100;
    var s;
    try {
      s = v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      s = v.toFixed(2);
    }
    return '₹' + s;
  }

  var DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function checked(sub, name) {
    return sub.querySelector('input[name="' + name + '"]:checked');
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  // First delivery on/after today that falls on the given weekday (0=Sun..6=Sat).
  function nextWeekday(dow) {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + ((dow - d.getDay() + 7) % 7));
    return d;
  }

  // First delivery on/after today that lands on the given day-of-month (clamped to real days).
  function nextMonthDay(dom) {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    function make(y, m) {
      var last = new Date(y, m + 1, 0).getDate();
      return new Date(y, m, Math.min(dom, last));
    }
    var cand = make(t.getFullYear(), t.getMonth());
    if (cand < t) cand = make(t.getFullYear(), t.getMonth() + 1);
    return cand;
  }

  // Full list of delivery dates for the plan. Weekly/fortnightly step by whole
  // weeks; monthly steps by month keeping the chosen day-of-month (clamped).
  function buildSchedule(start, deliveries, intervalWeeks, monthly, dom) {
    var out = [];
    for (var i = 0; i < deliveries; i++) {
      var d;
      if (monthly) {
        var m = start.getMonth() + i;
        var y = start.getFullYear() + Math.floor(m / 12);
        var mm = ((m % 12) + 12) % 12;
        var last = new Date(y, mm + 1, 0).getDate();
        d = new Date(y, mm, Math.min(dom, last));
      } else {
        d = new Date(start);
        d.setDate(d.getDate() + i * intervalWeeks * 7);
      }
      out.push(d);
    }
    return out;
  }

  // Weekdays the shopper ticked (0=Sun..6=Sat), sorted. Multiple = multiple
  // deliveries per week/fortnight.
  function getSelectedDays(sub) {
    var nodes = sub.querySelectorAll('input[name="lfx_day"]:checked');
    var arr = [];
    for (var i = 0; i < nodes.length; i++) arr.push(parseInt(nodes[i].value, 10));
    arr.sort(function (a, b) {
      return a - b;
    });
    return arr;
  }

  // Delivery dates when several weekdays are chosen: each period repeats every
  // selected day, stepping whole intervals. Returns a flat, date-sorted list.
  function buildWeeklySchedule(selectedDays, periods, intervalWeeks) {
    var firsts = selectedDays.map(nextWeekday);
    var out = [];
    for (var p = 0; p < periods; p++) {
      for (var j = 0; j < firsts.length; j++) {
        var d = new Date(firsts[j]);
        d.setDate(d.getDate() + p * intervalWeeks * 7);
        out.push(d);
      }
    }
    out.sort(function (a, b) {
      return a - b;
    });
    return out;
  }

  function recompute(sub) {
    var plan = checked(sub, 'lfx_plan');
    var size = checked(sub, 'lfx_size');
    if (!plan || !size) return;

    // Delivery-cadence visibility depends on the chosen plan:
    //  - Weekly + fortnightly are always available.
    //  - "Every month" is available for 3 / 6 / 12-month plans; disabled only on
    //    the 1-month plan (where it would be a single delivery).
    var planMonthsForFreq = parseInt(plan.getAttribute('data-months'), 10);
    var freqWeekly = sub.querySelector('input[name="lfx_freq"][data-weeks="1"]');
    var freqFortnight = sub.querySelector('input[name="lfx_freq"][data-weeks="2"]');
    var freqMonthly = sub.querySelector('input[name="lfx_freq"][data-weeks="4"]');

    // Weekly + fortnightly are always available.
    [freqWeekly, freqFortnight].forEach(function (input) {
      if (!input) return;
      var chip = input.closest('.lf-subx__chip');
      if (chip) chip.hidden = false;
      input.disabled = false;
    });

    if (freqMonthly) {
      // "Every month" is a single delivery on the 1-month plan, so disable it
      // there; enabled for 3 / 6 / 12-month plans.
      var blockMonthlyFreq = planMonthsForFreq <= 1;
      freqMonthly.disabled = blockMonthlyFreq;
      var freqMonthlyChip = freqMonthly.closest('.lf-subx__chip');
      if (freqMonthlyChip) freqMonthlyChip.classList.toggle('is-disabled', blockMonthlyFreq);
    }

    if (freqMonthly && freqMonthly.disabled && freqMonthly.checked) {
      // Monthly plan hid the cadence that was selected — fall back to a weekly one.
      var altFreq = freqFortnight || freqWeekly;
      if (altFreq) altFreq.checked = true;
    }

    var freq = checked(sub, 'lfx_freq');
    if (!freq) return;

    // Egg products count "Total eggs"; other products leave this blank and the
    // count row / property is dropped (data-lf-subx-unit set in lf-subscribe.liquid).
    var unit = sub.getAttribute('data-lf-subx-unit') || '';

    var months = parseInt(plan.getAttribute('data-months'), 10);
    var discPct = parseFloat(plan.getAttribute('data-disc')) || 0;
    var intervalWeeks = parseInt(freq.getAttribute('data-weeks'), 10);
    var price = parseInt(size.getAttribute('data-price'), 10); // paise, per delivery
    var pcs = parseInt((size.getAttribute('data-label') || '').match(/\d+/), 10) || 0;
    // Step 4 adapts to the frequency: weekday chips for weekly plans, a date for monthly.
    var monthly = intervalWeeks >= 4;

    // How many delivery days per period the shopper picked (weekly/fortnightly).
    var selectedDays = monthly ? [] : getSelectedDays(sub);
    if (!monthly && selectedDays.length === 0) selectedDays = [1]; // default to Monday
    var numDays = monthly ? 1 : selectedDays.length;

    // Base delivery events at one per interval:
    //   Monthly cadence = one per month (6mo→6, yearly→12).
    //   Weekly / fortnightly use the true ~4.345 weeks-per-month rate.
    var baseIntervals =
      intervalWeeks >= 4
        ? months
        : Math.round((months * WEEKS_PER_MONTH) / intervalWeeks);
    baseIntervals = Math.max(1, baseIntervals);
    // Each selected weekday adds a delivery in every interval, so the payment
    // scales with the number of days chosen.
    var deliveries = baseIntervals * numDays;
    var gross = deliveries * price;
    var discount = Math.round((gross * discPct) / 100);
    var payable = gross - discount;
    var totalEggs = deliveries * pcs;
    var daysGroup = sub.querySelector('[data-lf-subx-days]');
    var dateGroup = sub.querySelector('[data-lf-subx-dates]');
    var whenLabel = sub.querySelector('[data-lf-subx-when-label]');
    var daysHint = sub.querySelector('.lf-subx__days-hint');
    if (daysGroup) daysGroup.hidden = monthly;
    if (daysHint) daysHint.hidden = monthly;
    if (dateGroup) dateGroup.hidden = !monthly;
    if (whenLabel) whenLabel.textContent = monthly ? 'Delivery date' : 'Delivery day';

    var start, dayLabel;
    if (monthly) {
      var dateSel = sub.querySelector('[data-lf-subx-date]');
      var dom = dateSel ? parseInt(dateSel.value, 10) : 1;
      start = nextMonthDay(dom);
      dayLabel = ordinal(dom) + ' of each month';
    } else {
      // Earliest upcoming date among the chosen weekdays is the start.
      var firstDates = selectedDays.map(nextWeekday);
      start = firstDates.reduce(function (a, b) {
        return b < a ? b : a;
      });
      var names = selectedDays
        .map(function (d) {
          return DOW[d];
        })
        .join(', ');
      dayLabel = names + (intervalWeeks === 2 ? ' (every 2 weeks)' : ' (weekly)');
    }

    var end = new Date(start);
    end.setMonth(end.getMonth() + months);
    var starts = fmtDate(start);
    var ends = fmtDate(end);

    // hidden add-to-cart inputs
    set(sub, '[data-lf-subx-variant]', size.value);
    set(sub, '[data-lf-subx-qty]', String(deliveries));
    set(sub, '[data-lf-subx-p-plan]', plan.getAttribute('data-label'));
    set(sub, '[data-lf-subx-p-size]', size.getAttribute('data-label'));
    set(sub, '[data-lf-subx-p-freq]', freq.getAttribute('data-label'));
    set(sub, '[data-lf-subx-p-deliv]', String(deliveries));
    if (unit) set(sub, '[data-lf-subx-p-eggs]', totalEggs.toLocaleString('en-IN') + ' ' + unit);
    set(sub, '[data-lf-subx-p-day]', dayLabel);
    set(sub, '[data-lf-subx-p-disc]', discPct + '% (-' + money(discount) + ')');
    set(sub, '[data-lf-subx-p-pay]', money(payable));
    set(sub, '[data-lf-subx-p-starts]', starts);
    set(sub, '[data-lf-subx-p-ends]', ends);

    // Full delivery schedule → order property (visible on the order later).
    var schedule = monthly
      ? buildSchedule(start, deliveries, intervalWeeks, true, dom)
      : buildWeeklySchedule(selectedDays, baseIntervals, intervalWeeks);
    var scheduleStr = schedule.map(fmtDate).join(', ');
    set(sub, '[data-lf-subx-p-schedule]', scheduleStr);

    // live summary
    var countRow = unit
      ? '<div class="lf-subx__sum-row"><span>Total ' +
        unit +
        '</span><b>' +
        totalEggs.toLocaleString('en-IN') +
        ' ' +
        unit +
        '</b></div>'
      : '';

    // Effective per-unit rate AFTER the plan discount: "per egg" for egg products
    // (payable ÷ total eggs), otherwise per-pack (payable ÷ deliveries) for ghee,
    // oils, honey, etc.
    var rateRow;
    if (unit && totalEggs > 0) {
      var unitSingular = unit.replace(/s$/, ''); // "eggs" → "egg"
      rateRow =
        '<div class="lf-subx__sum-row"><span>Per ' +
        esc(unitSingular) +
        ' (after discount)</span><b>' +
        money2(payable / totalEggs) +
        '</b></div>';
    } else if (deliveries > 0) {
      rateRow =
        '<div class="lf-subx__sum-row"><span>Per pack (after discount)</span><b>' +
        money2(payable / deliveries) +
        '</b></div>';
    } else {
      rateRow = '';
    }

    var summary = sub.querySelector('[data-lf-subx-summary]');
    if (summary) {
      summary.innerHTML =
        '<div class="lf-subx__sum-row"><span>Deliveries</span><b>' +
        deliveries +
        ' × ' +
        esc(size.getAttribute('data-label')) +
        '</b></div>' +
        countRow +
        rateRow +
        '<div class="lf-subx__sum-row"><span>Delivery day</span><b>' +
        esc(dayLabel) +
        '</b></div>' +
        '<div class="lf-subx__sum-row"><span>Window</span><b>' +
        starts +
        ' → ' +
        ends +
        '</b></div>' +
        '<div class="lf-subx__sum-row"><span>Total</span><b>' +
        money(gross) +
        '</b></div>' +
        '<div class="lf-subx__sum-row lf-subx__sum-disc"><span>Discount (' +
        discPct +
        '%)</span><b>−' +
        money(discount) +
        '</b></div>' +
        '<div class="lf-subx__sum-row lf-subx__sum-total"><span>Payable</span><b>' +
        money(payable) +
        '</b></div>';
    }
    var totalEl = sub.querySelector('[data-lf-subx-total]');
    if (totalEl) totalEl.textContent = money(payable);

    // "You save" note — plain text below the summary box.
    var saveNote = sub.querySelector('[data-lf-subx-save]');
    if (saveNote) {
      if (discount > 0) {
        saveNote.textContent = 'You save ' + money(discount);
        saveNote.hidden = false;
      } else {
        saveNote.textContent = '';
        saveNote.hidden = true;
      }
    }
  }

  function set(sub, sel, val) {
    var el = sub.querySelector(sel);
    if (el) el.value = val;
  }

  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function panelOf(toggle) {
    return document.getElementById(toggle.getAttribute('aria-controls'));
  }

  function openPanel(toggle) {
    var panel = panelOf(toggle);
    if (!panel) return;
    // Portal to <body> so no transformed/overflow ancestor traps the fixed
    // overlay (that was blocking scroll inside the dialog).
    if (panel.parentNode !== document.body) document.body.appendChild(panel);
    panel._lfxToggle = toggle;
    panel.hidden = false;
    document.documentElement.classList.add('lf-subx-lock');
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
    });
    toggle.setAttribute('aria-expanded', 'true');
    recompute(panel);
  }

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.hidden = true;
    document.documentElement.classList.remove('lf-subx-lock');
    if (panel._lfxToggle) panel._lfxToggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-lf-subx-toggle]');
    if (toggle) {
      var panel = panelOf(toggle);
      if (panel && panel.hidden) openPanel(toggle);
      else closePanel(panel);
      return;
    }
    // close button, or a click on the backdrop (the overlay itself, not the dialog)
    var closer = event.target.closest('[data-lf-subx-close]');
    var onBackdrop = event.target.matches && event.target.matches('[data-lf-subx-panel]');
    if (closer || onBackdrop) {
      var p = event.target.closest('[data-lf-subx-panel]');
      if (p) closePanel(p);
    }
  });

  document.addEventListener('change', function (event) {
    var panel = event.target.closest('[data-lf-subx-panel]');
    if (panel) recompute(panel);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-lf-subx-panel]').forEach(function (p) {
      if (!p.hidden) closePanel(p);
    });
  });

  // Take over the Subscribe submit: add the item (so its plan/properties travel),
  // then send the shopper straight to checkout — never to the cart page — carrying
  // the plan's discount code through so the checkout total = the Payable amount.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var panel = form && form.closest ? form.closest('[data-lf-subx-panel]') : null;
      if (!panel) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      recompute(panel); // make sure id / quantity / properties are current
      var plan = checked(panel, 'lfx_plan');
      var code = plan ? plan.getAttribute('data-code') : '';
      var btn = panel.querySelector('[data-lf-subx-total]');
      var confirm = panel.querySelector('.lf-subx__confirm');
      if (confirm) confirm.disabled = true;

      // Isolated subscription checkout: wipe any existing cart first so the
      // checkout contains ONLY this subscription (its plan/properties still need
      // the cart to travel — that's the sole client-side way to carry them).
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add failed');
          return r.json();
        })
        .then(function () {
          // Buy-it-now flow: skip the cart page and go straight to checkout, with
          // the plan's discount applied via the checkout URL param. Using
          // /checkout?discount=CODE applies THIS plan's code to the checkout,
          // rather than /discount/CODE which stores codes in the session and can
          // let a previously-tested code linger/stack.
          // NOTE: each CODE must exist in Admin → Discounts with the matching
          // percentage + scope, and be set to apply to subscription purchases.
          if (code) {
            window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(function () {
          if (confirm) confirm.disabled = false;
          if (btn) btn.textContent = 'Please try again';
        });
    },
    true // capture phase so we run before the theme's product-form-component
  );

  function openFromHash() {
    if (window.location.hash !== '#lf-subscribe') return;
    var toggle = document.querySelector('[data-lf-subx-toggle]');
    if (toggle) openPanel(toggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
})();
